import BaseBlock from "./BaseBlock";
import Swiper, {Navigation, Pagination} from "swiper";
import ImageCompare from "image-compare-viewer";

class BeforeAfterGallery extends BaseBlock {

    init() {
        /**
         *
         * @type {HTMLDivElement}
         */
        const galleryEl = this.block.querySelector(".before-after-gallery");
        const sliderEl = this.block.querySelector(".swiper");

        if (galleryEl.classList.contains("type-overlapping")) {
            const imgPairs = galleryEl.querySelectorAll('.image-compare');
            imgPairs.forEach((el) => {
                new ImageCompare(el, {
                    addCircle: true,
                    showLabels: true
                }).mount();
            });
        }
        else {
            if (sliderEl) {
                const swiper = new Swiper(sliderEl, {
                    loop: true,
                    navigation: {
                        prevEl: this.block.querySelector(".slider-btn-prev"),
                        nextEl: this.block.querySelector(".slider-btn-next"),
                    },
                    pagination: {
                        el: this.block.querySelector(".slider-pagination")
                    },
                    modules: [Navigation, Pagination]
                });
            }
        }
    }
}

export default BeforeAfterGallery;
